import { EazyUpdateDelete } from "@admin/pages/eazy-update-delete";
import type { RouteObject } from "react-router-dom";

const routes = [{ index: true, element: <EazyUpdateDelete /> }] satisfies RouteObject[];

export const eazyUpdateDeleteRoute = {
  path: "/eazy-update-delete",
  children: routes,
} satisfies RouteObject;
